import Glide from '@glidejs/glide';

if (document.querySelector('.js-glide-post_page')) {
    const startAt = 0
    const slider = new Glide('.js-glide-post_page', {
        type: 'carousel',
        startAt: startAt,
        focusAt: 'center',
        perView: 3,
        breakpoints: {
            1024: {
                perView: 1
            }
        }
    })
    
    slider.mount()
}

if (document.querySelectorAll('.content__single-products .glide__bullet').length) {
    document.getElementById(`slideBullet-${startAt}`).classList.add('active')

    
    document.querySelectorAll('.content__single-products .glide__bullet').forEach(item => {
        item.addEventListener('click', () => {
            document.querySelectorAll('.content__single-products .glide__bullet').forEach(bullet => {
                bullet.classList.remove('active')
            });
            slider.go(`=${item.id.split('-')[1]}`)
            item.classList.add('active')
        })
    })

    slider.on('run.after', () => {
        var activeElement = document.querySelector('.content__single-products .glide__slide--active')
        var activeId = activeElement.id.split('-')[1]
    
        document.querySelectorAll('.content__single-products .glide__bullet').forEach(bullet => {
            bullet.classList.remove('active')
        });
    
        document.getElementById(`slideBullet-${activeId}`).classList.add('active')
    })
}
